import { Languages } from './../_enumerations/languages';
import { APP_CONSTS } from './../_configs/consts';
import { APP_CONFIGS } from '../_configs/appconfigs';
import { WEB_API_URLS } from './../_configs/webapiurls';
import { Observable } from 'rxjs/Observable';
import { SJIAppContext } from './../models/sjiappcontext';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Observer } from 'rxjs';
import { DOCUMENT } from '@angular/platform-browser';
import { UserManagerSettings } from 'oidc-client';
import { environment } from '../../environments/environment';
import { Promos } from '../order/modules/Promos.module';
/**
 * Work for handle current running application's shared information.
 * Note: This is a shared service across the whole application.
 * It is a  singleton services.
 */
@Injectable(
    {
        /**
         * Define SJIAppContextService as a shared service.
         * Angular creates a single, shared instance of the service and injects into any class that asks for it.
         */
        providedIn: 'root'
    }
)
export class AppContextService {
    private currentDomain = '';
    /** It is value of hours offset for timezone. negative value. for example value = -5 for Eastern Standard Time to UTC. */
    timeZoneOffset: string;
    // appContext: SJIAppContext = new SJIAppContext();
     /**
     * Emit the CompanyId when selected Company from the drop down on the top menu.
     * public event. Work for admin portal.
     * Work for setCompanyId method.
     */
    public companyChanged = new EventEmitter<string>();

    constructor(private http: HttpClient, @Inject(DOCUMENT) private document) {
        this.currentDomain = this.getCurrentDomain();
        const appContext = this.getAppContext();
        if (!appContext || appContext == null) {
            this.updateAppContext(new SJIAppContext());
        }

        this.timeZoneOffset = String(-(new Date()).getTimezoneOffset() / 60);
        console.log("current time zone", this.timeZoneOffset);
    }

    /**
     *  Only need to call initDomain() method one time in the main app component's constructor.
    */
    async initDomain() {
        const appContext = this.getAppContext();
        appContext.domain = this.getCurrentDomain();
        const response: any = await this.http.get<SJIAppContext>(WEB_API_URLS.common_context_initdomain,
            { params: { domain: appContext.domain } }).toPromise();
        console.log('Called initDomain response: ' + JSON.stringify(response));
        if (response && response.isSuccess) {
            appContext.isAdminPortal = response.isAdminPortal;
            this.updateAppContext(appContext);
        } else {
            this.removeAppContext();
        }
    }
    /**
     *  Only need to call initContext() method one time in the main app component's constructor after init securityService.
    */
    // async initContext() {
    //   const appContext = this.getAppContext();
    //   const response: any = await this.http.post<SJIAppContext>(
    //     WEB_API_URLS.common_context_initappcontext, {domain: appContext.domain}).toPromise();
    //     console.log('Called initContext response: ' + JSON.stringify(response));
    //     if (response && response.isSuccess) {
    //         //appContext.companyId = response.companyId;
    //         //appContext.companyName = response.companyName;
    //         //appContext.companyTheme = response.companyTheme;
    //         appContext.isAdminPortal = response.isAdminPortal;
    //         this.updateAppContext(appContext);
    //     } else {
    //         this.removeAppContext();
    //     }
    // }
    /**
     * Get current accessing company portal's information from local storage.
     * if no appcontext, create a new instance.
     */
    getAppContext(): SJIAppContext {
        if (localStorage.getItem(APP_CONSTS.appContext + this.currentDomain)) {
            return JSON.parse(localStorage.getItem(APP_CONSTS.appContext + this.currentDomain)) as SJIAppContext;
        } else {
            return new SJIAppContext();
        }
    }

    /**
     * Get current access portal's associated client Id.
     *  Note: For Admin portal, value = 'admin'.
     *  For company portal, value = company's Id (int primary key of table dbo.Company).
     */
    getClientId() {
        return 'admin';
    }

    /**
     * Get current accessing End User portal's company Id.
     * Note: CompanyId could be different with ClientId.
     * If no selected companyId, return '0'.
     */
    getCompanyId() {
        const appContext = this.getAppContext();
        if (appContext && appContext.companyId ) {
            console.log('getCompanyId: ' + appContext.companyId);
            return appContext.companyId;
        } else {
            return '0';
        }
    }


    /**
    * Get current accessing End User portal's company Name.
    */
    getCompanyName() {
        const appContext = this.getAppContext();
        if (appContext && appContext.companyName && appContext.companyName.length > 0) {
            return appContext.companyName;
        } else {
            return '';
        }
    }


    /**
     * When update companyId, also need to get back company name from server side and update SJIAppContext.companyName property.
     * Note: And public companyChanged event will be raised.
     * @param companyId selected company from top menu. Company's primary key. Field "Id" in table dbo.Company.
     */
    async setCompanyId(companyId: string): Promise<string> {

        const appContext = this.getAppContext();

        //
        // Note: Need to immediatly update appContext.
        // which need to inject to http request header and send to server side.
        //
        if (appContext) {
            appContext.companyId = companyId;
            this.updateAppContext(appContext);
        }

        //
        // Consistent company name.
        //
        const response = await this.http.get<any>(WEB_API_URLS.common_get_company_by_id,  {params: {companyId: companyId}}).toPromise();
         console.log('AppContext Service setCompanyId called. response: ' + JSON.stringify(response));
        if (response) {
            appContext.companyName = response.name;
            appContext.companyTheme = response.theme;
            this.updateAppContext(appContext);
        }
        console.log('AppContext Service setCompanyId called. AppContext: ' + JSON.stringify(appContext));
        // Raised company changed event to public.
        this.companyChanged.emit(companyId);
        return companyId;
     }

    setLanguage(userLanguage: string) {
        // console.log('setAppContextDefaultLangauge called:' + userLanguage);
        const appContext = this.getAppContext();
        if (appContext) {
            appContext.language = userLanguage;
            this.updateAppContext(appContext);
        }
    }

    /**
     * Save current accessing company portal's app context information into local storage.
     *
     */
    updateAppContext(inputAppContext: SJIAppContext) {
        if (inputAppContext) {
            localStorage.setItem(APP_CONSTS.appContext + this.currentDomain, JSON.stringify(inputAppContext));
            // this.appContext = inputAppContext;
        }
    }

    /**
     * Remove current accessing company portal's associated info from local storage.
     */
    removeAppContext() {
        localStorage.removeItem(APP_CONSTS.appContext + this.currentDomain);
    }

    /**
     * Get current accessing portal's domain.
     */
    getCurrentDomain() {
        let domain = '';
        if (document.location.port.length === 0) {
            // Return domain without port. Note: Port = 80 as default.
            domain = document.location.protocol + '//' + document.location.hostname;
        } else {
            // Return domain with port. Note: Port != 80 in this case.
            domain = document.location.protocol + '//' + document.location.hostname + ':' + document.location.port;
        }
        return domain;
    }

     /**
     * Get current accessing portal's rendering language.
     */
    getLanguage(): string {
        const appContext = this.getAppContext();
        if (appContext != null && appContext.language) {
           if ( appContext.language === 'ZH' || appContext.language === '4' ) {
             return Languages.Chinese_CHS;
           }
           if ( appContext.language === 'ES' || appContext.language === '3' ) {
            return Languages.Spanish_US;
          }
          if ( appContext.language === 'FR' || appContext.language === '2' ) {
            return Languages.French_CA;
          }
        }
        return Languages.English_US;
      }

      getLanguageId(): any {
        const appContext = this.getAppContext();
        if (appContext != null && appContext.language) {
           if ( appContext.language === 'ZH' || appContext.language === '4' ) {
             return 4;
           }
           if ( appContext.language === 'ES' || appContext.language === '3' ) {
            return 3;
          }
          if ( appContext.language === 'FR' || appContext.language === '2' ) {
            return 2;
          }
        }
        return 1;
      }

    // Disabled.
    //   getHttpHeader(): any {
    //     return {
    //       currentLanguage: this.getLanguage(),
    //       companyId: this.getCompanyId(),
    //       timeZoneOffset: this.timeZoneOffset
    //     };
    //   }
}
